<div class="container-fluid py-4 px-4">

  <div class="container-fluid container-card mb-4">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-6">
        <h1 class="heading-1">Non Group Tenant List</h1>
      </div>
      <div class="col-12 col-md-6 col-lg-6">
        <div class="form-group group-input">
          <input
            type="search"
            class="form-control"
            placeholder="Business Unit Name"
            [(ngModel)]="searchTerm"
            (input)="onSearchInput($event)">
          <img src="assets/icons/search.png" alt="">
        </div>
      </div>
    </div>

    <div class="container-fluid container-box-image my-4">

      <!-- Loading state untuk initial load -->
      <div *ngIf="isLoadingNonGroup" class="text-center py-4">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <!-- Tenant Items -->
      <div class="row my-2" *ngIf="!isLoadingNonGroup">
        <div class="col-6 col-md-3 col-lg-3" *ngFor="let item of itemTenantNonGroup">
          <div class="box-image" [routerLink]="['/office-lease/tenant-list/business-unit-detail', item.id]" routerLinkActive="router-link-active" >
            <!-- <img src="{{ item.logo }}" alt="" width="150" height="150"> -->
             <div [ngSwitch]="true">
              <img *ngSwitchCase="item.logo != null" src="{{ item.logo }}" alt="">
              <img *ngSwitchDefault src="assets/images/default-logo-tenant.png" alt="">
             </div>
          </div>
          <h5 class="text-center title">{{ item.name }}</h5>
        </div>
      </div>

      <!-- Show More Button -->
      <div class="section-button d-flex justify-content-center my-4" *ngIf="!isLoadingNonGroup">
        <button
          class="btn btn-show-more"
          *ngIf="isShowMoreNonGroup"
          (click)="onClickMoreNonGroup()"
          [disabled]="isLoadingMoreNonGroup">
          <span *ngIf="!isLoadingMoreNonGroup">Show More</span>
          <span *ngIf="isLoadingMoreNonGroup">
            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
            Loading...
          </span>
        </button>
      </div>

      <!-- No Data Message -->
      <div *ngIf="!isLoadingNonGroup && itemTenantNonGroup.length === 0" class="text-center py-4">
        <p class="text-muted">No tenants found</p>
      </div>

    </div>
  </div>
  <div class="container-fluid container-card mb-4">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-6">
        <h1 class="heading-1">Group Tenant List</h1>
      </div>
      <div class="col-12 col-md-6 col-lg-6">
        <div class="form-group group-input">
          <input
            type="search"
            class="form-control"
            placeholder="Business Unit Name"
            [(ngModel)]="searchTerm"
            (input)="onSearchInput($event)">
          <img src="assets/icons/search.png" alt="">
        </div>
      </div>
    </div>

    <div class="container-fluid container-box-image my-4">

      <!-- Loading state untuk initial load -->
      <div *ngIf="isLoadingGroup" class="text-center py-4">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <!-- Tenant Items -->
      <div class="row my-2" *ngIf="!isLoadingGroup">
        <div class="col-6 col-md-3 col-lg-3" *ngFor="let item of itemTenantGroup">
          <div class="box-image" [routerLink]="['/office-lease/tenant-list/business-unit-detail', item.id]" routerLinkActive="router-link-active" >
            <!-- <img src="{{ item.logo }}" alt="" width="150" height="150"> -->
             <div [ngSwitch]="true">
              <img *ngSwitchCase="item.logo != null" src="{{ item.logo }}" alt="">
              <img *ngSwitchDefault src="assets/images/default-logo-tenant.png" alt="">
             </div>
          </div>
          <h5 class="text-center title">{{ item.name }}</h5>
        </div>
      </div>

      <!-- Show More Button -->
      <div class="section-button d-flex justify-content-center my-4" *ngIf="!isLoadingGroup">
        <button
          class="btn btn-show-more"
          *ngIf="isShowMoreGroup"
          (click)="onClickMoreGroup()"
          [disabled]="isLoadingMoreGroup">
          <span *ngIf="!isLoadingMoreGroup">Show More</span>
          <span *ngIf="isLoadingMoreGroup">
            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
            Loading...
          </span>
        </button>
      </div>

      <!-- No Data Message -->
      <div *ngIf="!isLoadingGroup && itemTenantGroup.length === 0" class="text-center py-4">
        <p class="text-muted">No tenants found</p>
      </div>

    </div>
  </div>
</div>
